/**
 * The admin console's pages and their paths — and nothing else.
 *
 * Split from `nav.ts` because the router imports it: whatever this file holds ships in
 * the main bundle every buyer downloads. The nav's labels and icons stay in `nav.ts`,
 * which only the lazy `AdminArea` chunk imports. `pathFor` and `parseRoute` both read
 * `ADMIN_PATHS`, and the type makes the table total, so a page cannot exist without one.
 */

export type AdminPage =
  | 'sellers'
  | 'buyers'
  | 'lives'
  | 'reporting'
  | 'push'
  | 'banners'
  | 'referrals'
  | 'review'
  | 'taxonomy'
  | 'settings.one'
  | 'settings.two'
  | 'audit';

/**
 * Static paths only (D46 addendum, 2026-10-08): no parameter, so this stays inside the
 * hand-rolled router's trigger. `/admin` itself is the default page.
 */
export const ADMIN_PATHS: Readonly<Record<AdminPage, string>> = {
  sellers: '/admin/sellers',
  buyers: '/admin/buyers',
  lives: '/admin/lives',
  reporting: '/admin/reporting',
  push: '/admin/push',
  banners: '/admin/banners',
  referrals: '/admin/referrals',
  review: '/admin/review',
  taxonomy: '/admin/taxonomy',
  'settings.one': '/admin/settings/one',
  'settings.two': '/admin/settings/two',
  audit: '/admin/audit',
};

/** The design opens on Sellers. */
export const ADMIN_DEFAULT_PAGE: AdminPage = 'sellers';
